module.exports = __webpack_public_path__ + "img/portfolio.3cb14824.svg";